import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

/**
 * Initializes Swiper sliders for all elements with the class 'js-history-slider',
 * if such elements exist on the page.
 *
 * @returns {void}
 */
export const initializeHistorySliders = () => {
    // Query all elements with the class 'js-history-slider'
    const sliders = document.querySelectorAll('.js-history-slider');

    // Check if any sliders exist
    if (sliders.length === 0) {
        return;
    }

    // Loop through each slider element and initialize Swiper for it
    sliders.forEach((slider) => {
        new Swiper(slider, {
            modules: [Navigation],
            loopAdditionalSlides: 1,
            loop: true,
            centeredSlides: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                  slidesPerView: 1.185,
                },
                500: {
                    slidesPerView: 1.8,
                },
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                },
            }
        });
    });
};

/**
 * Initializes Swiper sliders for all elements with the class 'js-goals-slider',
 * if such elements exist on the page.
 *
 * @returns {void}
 */
export const initializeGoalsSliders = () => {
    // Query all elements with the class 'js-goals-slider'
    const sliders = document.querySelectorAll('.js-goals-slider');

    // Check if any sliders exist
    if (sliders.length === 0) {
        return;
    }

    // Loop through each slider element and initialize Swiper for it
    sliders.forEach((slider) => {
        let text = slider.closest('.block-accordion-goals-slider').dataset.text.split(';');

        new Swiper(slider, {
            slidesPerView: 1,
            loop: true,
            spaceBetween: 30,
            modules: [Pagination, Autoplay],
            autoplay: {
                delay: 5000,
            },
            pagination: {
                el: '.block-accordion-goals-slider__pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    return '<li class="' + className + '"><a href="#" class="fw-500 block-accordion-goals-slider__pagination-link">' + (text[index]) + '</a></li>';
                },
            },
            on: {
                slideChange: function () {
                    let swiper = this;
                    let parentWrapper = slider.closest('.block-accordion-goals-slider');
                    const animatonBlock = parentWrapper.querySelector('.block-accordion-goals-slider__progressbar-fill');
                    
                    updateCounterValue(parentWrapper, swiper.realIndex);

                    updateActiveContent(parentWrapper, swiper.realIndex);

                    animatonBlock.classList.remove('animate');
                    setTimeout(() => {
                        animatonBlock.classList.add('animate');
                    }, 10);
                }
            }
        });
    });

};

/**
 * Updates the counter value based on the active slide's data-counter attribute.
 * 
 * @param {Element} wrapper - The Swiper wrapper element containing the slides.
 * @param {number} index - The index of the current active slide.
 */
const updateCounterValue = (wrapper, counterValue) => {
    // Increment the counter value
    let incrementedValue = parseInt(counterValue) + 1;

    // Format the value to always have two digits (01, 02, ..., 10, etc.)
    let formattedValue = incrementedValue.toString().padStart(2, '0');

    // Set the counter value to the element with the class .block-accordion-goals-slider__counter-value
    const counterElement = wrapper.closest('.block-accordion-goals-slider').querySelector('.block-accordion-goals-slider__counter-value');
    
    if (counterElement) {
        counterElement.textContent = formattedValue; // Update the counter value in the UI
    }
};

/**
 * Updates the active content section based on the current slide index.
 * It adds the active class to the content corresponding to the slide index and
 * removes it from all other content sections.
 * 
 * @param {Element} parentWrapper - The parent wrapper element containing the content sections.
 * @param {number} activeIndex - The index of the active slide.
 */
const updateActiveContent = (parentWrapper, activeIndex) => {
    // Find all content sections
    const allContentSections = parentWrapper.querySelectorAll('.block-accordion-goals-slider__text');

    // Loop through all content sections and toggle the active class
    allContentSections.forEach(function(content, index) {
        if (index === activeIndex) {
            content.classList.add('active'); // Add active class to the current content
        } else {
            content.classList.remove('active'); // Remove active class from others
        }
    });
}